import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VBtn,{attrs:{"icon":""}},[_c(VIcon,[_vm._v("mdi-bell")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }